import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Box, Container, Typography } from '@mui/material';
import {
    Command as BoardIcon,
} from 'react-feather';
import MetabaseEmbed from 'Components/boards/MetabaseEmbed'
import GrafanaEmbed from 'Components/boards/GrafanaEmbed';

const Boards = () => (
    <>
        <Helmet>
            <title>Boards</title>
        </Helmet>
        <Container maxWidth={false}>

            <Box sx={{ pt: 3 }}>
                <BoardIcon />
                <Typography paragraph>This is Boards. Coming Soon</Typography>
            </Box>
            <GrafanaEmbed />
            <MetabaseEmbed />



        </Container>

    </>
);

export default Boards;
